<template>
  <div>
    <div class="pt-20">
      <div class="card">
        <div class="card-body">
          <h2 class="card-title">Verify Identity</h2>
          <div class="card-description">We've sent a six-digit verification code to {{ mobileNo }} email.</div>
          <form class="otp_form">
            <div class="form-group otp-input-group">
              <label>Enter Code</label>
              <div class="row">
                <div class="col-lg-2">
                  <input
                    type="text"
                    v-validate="'required|digits:1'"
                    name="otp_1"
                    :class="{
                      input: true,
                      'is-danger': errors.has('otp_1'),
                      'is-success': !errors.has('otp_1')
                    }"
                    class="form-control form-control-sm"
                    v-model="otp_1"
                    maxlength="1"
                    id="1"
                    v-on:keyup="validatePassKey(1)"
                    required
                    tabindex="-1"
                  />
                </div>
                <div class="col-lg-2">
                  <input
                    type="text"
                    v-validate="'required|digits:1'"
                    name="otp_2"
                    :class="{
                      input: true,
                      'is-danger': errors.has('otp_2'),
                      'is-success': !errors.has('otp_2')
                    }"
                    class="form-control form-control-sm"
                    v-model="otp_2"
                    maxlength="1"
                    id="2"
                    v-on:keyup="validatePassKey(2)"
                    required
                  />
                </div>
                <div class="col-lg-2">
                  <input
                    type="text"
                    v-validate="'required|digits:1'"
                    name="otp_3"
                    :class="{
                      input: true,
                      'is-danger': errors.has('otp_3'),
                      'is-success': !errors.has('otp_3')
                    }"
                    class="form-control form-control-sm"
                    v-model="otp_3"
                    maxlength="1"
                    id="3"
                    v-on:keyup="validatePassKey(3)"
                    required
                  />
                </div>
                <div class="col-lg-2">
                  <input
                    type="text"
                    v-validate="'required|digits:1'"
                    name="otp_4"
                    :class="{
                      input: true,
                      'is-danger': errors.has('otp_4'),
                      'is-success': !errors.has('otp_4')
                    }"
                    class="form-control form-control-sm"
                    v-model="otp_4"
                    maxlength="1"
                    id="4"
                    v-on:keyup="validatePassKey(4)"
                    required
                  />
                </div>
                <div class="col-lg-2">
                  <input
                    type="text"
                    v-validate="'required|digits:1'"
                    name="otp_5"
                    :class="{
                      input: true,
                      'is-danger': errors.has('otp_5'),
                      'is-success': !errors.has('otp_5')
                    }"
                    class="form-control form-control-sm"
                    v-model="otp_5"
                    maxlength="1"
                    id="5"
                    v-on:keyup="validatePassKey(5)"
                    required
                  />
                </div>
                <div class="col-lg-2 mr-0">
                  <input
                    type="text"
                    v-validate="'required|digits:1'"
                    name="otp_6"
                    :class="{
                      input: true,
                      'is-danger': errors.has('otp_6'),
                      'is-success': !errors.has('otp_6')
                    }"
                    class="form-control form-control-sm"
                    v-model="otp_6"
                    maxlength="1"
                    id="6"
                    v-on:keyup="validatePassKey(6)"
                    required
                  />
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="success-msg-style" v-if="successMsg">
                {{ successMsg }}
              </div>
              <div class="error-style" v-if="errorMsg">{{ errorMsg }}</div>
              <div v-if="errors.any()">
                <button class="btn btn-primary btn-block" :disabled="!correctOTP">
                  Continue
                </button>
              </div>
              <div v-if="!errors.any()">
                <button type="submit" class="btn btn-primary btn-block" v-on:click.prevent="confirmOTP">
                  Continue
                </button>
              </div>
            </div>
            <div class="footer-links">
              <a v-on:click="resendOTP">Resend Code</a>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const jwtDecode = require("jwt-decode");
import { mapActions } from "vuex";

export default {
  name: "mfaAuth",
  data() {
    return {
      otp_1: "",
      otp_2: "",
      otp_3: "",
      otp_4: "",
      otp_5: "",
      otp_6: "",
      otp: "",
      formErrors: false,
      correctOTP: false,
      successMsg: null,
      errorMsg: null,
      mobileNo: null,
      token: null
    };
  },
  props: {
    twoFactorInput: {
      type: Object
    }
  },
  mounted() {
    const getMFAAuthDetails = JSON.parse(window.localStorage.getItem("MFATokenDetails"));
    const getMFAToken = this.twoFactorInput.twoFARequestId ? this.twoFactorInput.twoFARequestId : getMFAAuthDetails.twoFARequestId;
    const getMobileNo = this.twoFactorInput.partialphoneNumber ? this.twoFactorInput.partialphoneNumber : getMFAAuthDetails.partialphoneNumber;
    this.mobileNo = getMobileNo ? `${getMobileNo} and your` : "your";
    this.token = getMFAToken;
  },
  methods: {
    ...mapActions(["userSetTokens", "userLoadProfile"]),
    sendOtpToMobile() {
      this.$api
        .sendOtpToMobileFact({
          token: this.token
        })
        .then(
          () => {
            this.errorMsg = null;
          },
          error => {
            this.successMsg = null;
            this.errorMsg = error.body && error.body.message ? error.body.message : "Error while sending OTP to mobile";
          }
        );
    },
    confirmOTP() {
      this.successMsg = null;
      this.errorMsg = null;
      this.otp = this.otp_1 + this.otp_2 + this.otp_3 + this.otp_4 + this.otp_5 + this.otp_6;
      if (this.otp_1 === "" || this.otp_2 === "" || this.otp_3 === "" || this.otp_4 === "" || this.otp_5 === "" || this.otp_6 === "") {
        this.errorMsg = "Verification code should not be blank.";
      } else {
        this.errorMsg = null;
      }
      if (this.otp_1 && this.otp_2 && this.otp_3 && this.otp_4 && this.otp_5 && this.otp_6) {
        /*userAlreadyLoggedIn:true //Commented this key as this feature is not yet deployed in stage and other environments
            and later this key needs to be added in the below payload after that feature is deployed.*/
        this.$api
          .mfaValidateFact({
            twoFAToken: this.token,
            otp: this.otp
          })
          .then(
            response => {
              this.correctOTP = true;
              this.errorMsg = null;
              this.successMsg = response.body.message;
              if (response.body && response.body.result) {
                const { token, refreshToken } = response.body.result;
                this.userSetTokens({ token, refreshToken });
                const tokenObj = jwtDecode(token);
                localStorage.removeItem("MFATokenDetails");
                this.userLoadProfile(tokenObj.id);
              }
            },
            error => {
              this.successMsg = null;
              localStorage.removeItem("MFATokenDetails");
              this.errorMsg = error.body && error.body.message ? error.body.message : "Error while verifying the OTP";
            }
          );
      }
    },
    validatePassKey(id) {
      if (window.event.keyCode !== 8 && window.event.keyCode !== 46 && id !== 6) {
        window.document.getElementById(id + 1).focus();
      } else if ((window.event.keyCode === 8 || window.event.keyCode === 46) && id !== 1) {
        window.document.getElementById(id - 1).focus();
      }
      if (window.event.keyCode === 37) {
        window.document.getElementById(id - 1).focus();
      }
      let isBlank = false;
      for (let i = 1; i <= 6; i++) {
        if (window.document.getElementById(i).value === "") {
          isBlank = true;
          break;
        }
      }
      if (!isBlank) {
        this.errorMsg = null;
      }
    },
    resendOTP() {
      this.errorMsg = null;
      this.successMsg = null;
      this.$api
        .mfaResendCodeFact({
          twoFAToken: this.token
        })
        .then(
          () => {
            this.successMsg = "The code has been resent.";
          },
          error => {
            this.errorMsg = error.body && error.body.message ? error.body.message : "Error while resending the OTP";
          }
        );
    }
  }
};
</script>

<style lang="scss" scoped>
.link-style {
  font-size: 14px;
  text-align: center;
  padding-top: 5px;
}

.error-style {
  font-size: 12px;
  color: #ffa500;
  padding-bottom: 15px;
  text-align: center;
}

.success-msg-style {
  font-size: 12px;
  color: #449d44;
  padding-bottom: 15px;
  text-align: center;
}
</style>
<style scoped lang="scss" src="@/assets/auth-screen.scss"></style>
